import React from 'react'
import { ZoneIds } from '@/domain/zoneIds'
import CenterCarousel from '../CenterCarousel/CenterCarousel'
import { CenterFeed } from '@/types/models'
import { ArrowRight } from 'react-bootstrap-icons'
import { isNonEmptyArray, isNonEmptyString } from '@/utils/checks'
import LinkButton from '@/components/atoms/LinkButton/LinkButton'

export const NearbyBlogRelatedCentersCarousel = ({
  firstTag,
  sectionHeading,
  centers,
  sectionLink,
  isLoading = true
}: {
  firstTag: string
  sectionHeading: string
  centers: CenterFeed[]
  sectionLink: string
  isLoading: boolean
}) => {
  return (
    <div className="my-10 flex flex-col gap-4 border-y border-gray-300 pb-10 pt-8">
      <CenterCarousel
        centers={centers}
        useFieldsVariable={true}
        sectionHeading={sectionHeading}
        hideDescription={false}
        headerWeight="medium"
        headerSize="lg !leading-[26px]"
        noPadding={true}
        zoneId={ZoneIds.Nearby}
        isLoading={isLoading}
        termTitle={firstTag}
        HeaderTag="h2"
      />

      {!isLoading &&
        isNonEmptyArray(centers) &&
        isNonEmptyString(sectionLink) && (
          <div className="flex h-10 justify-start">
            <LinkButton
              label={`View All ${firstTag} Treatment Centers`}
              href={sectionLink}
              size="large"
              underline="always"
              iconElement={
                <ArrowRight
                  size="16"
                  className="ml-1"
                />
              }
            />
          </div>
        )}
    </div>
  )
}
